import styled, { css } from 'styled-components';

export const Container = styled.div<{
  gap: string;
  padding: string;
  template: string;
  isScrolled: boolean;
  hasScrollbar: boolean;
  scrollbarWidth?: number;
}>`
  display: grid;
  font-weight: 600;
  text-align: left;
  /* Same side borders as the list rows (list-card Container), so header
     columns start exactly where row columns start. */
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  ${({
    gap,
    theme,
    padding,
    template,
    isScrolled,
    hasScrollbar,
    scrollbarWidth,
  }) => css`
    margin: 0 ${16 + (scrollbarWidth ?? (hasScrollbar ? 8 : 0))}px 0 16px;
    grid-template-columns: ${template};
    gap: ${gap};
    color: ${theme.config.table.head.title};
    padding: ${padding};

    ${isScrolled &&
    css`
      box-shadow: ${theme.config.table.head.shadow};
    `}
  `}
`;
